/**
 * * Модель уровня сложности задачи
 */
export default class DifficultyLevelTaskModel  {
	/**
	 * * Номер уровня сложности
	 */
	DifficultyId!: string;
	/**
	 * * Название
	 */
	DifficultyName!: string;
	/**
	 * * Цвет
	 */
	DifficultyColor!: string;
	constructor(obj?: Partial<DifficultyLevelTaskModel>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
